import React from 'react'
// import backwardLine from "../../../../assets/media/home/stepper/backwardLine.png"
// import forwardLine from "../../../../assets/media/home/stepper/forwardLine.png"
// import { homePageAssets } from '../../../../assets/media'
// import connector from "../../../../assets/media/home/stepper/connector.png"
// import phoneConnector from "../../../../assets/media/home/stepper/phoneConnector.png"
// const { forwardLine, backwardLine} = homePageAssets
import stepper from "../../../../assets/media/home/stepper/stepper.png"
import stepperMobile from "../../../../assets/media/home/stepper/stepperMobile.png"
const Box = (props) => {
    const { stepNum, isReverse, heading, desc } = props
    return (
        <>
            <div className={`upperBox md:hidden flex items-center flex-row md:flex-col ${isReverse && "md:flex-col-reverse flex-row-reverse"}`}>
                <div className="stepperStep  md:mt-0 w-[9rem] h-[8rem]  md:h-[11rem] md:w-[7rem]  lg:h-[14rem] lg:w-[9rem] xl:h-[20rem] xl:w-[12rem] 2xl:h-[22rem] 2xl:w-[15rem] bg-white" >

                    <div className="stepContainer  w-full h-[6rem]  md:h-[7rem] lg:h-[10rem] xl:h-[11rem] 2xl:h-[13rem] bg-cover bg-center flex justify-center items-center">
                        {/* <div className="StepNumer lg:text-[16px] xl:text-[24px] 2xl:text-[26px] 2xl:font-[400] text-[#FFD700] -mt-3 lg:-mt-5">STEP {stepNum}</div> */}
                    </div>
                    <div className="content">
                        <div className="heading  md:text-[12px] lg:text-[14px] xl:text-[18px] 2xl:text-[24px] 2xl:leading-[24px] font-[700] text-center">
                            {heading}
                        </div>
                        <div className="desc md:text-[10px] lg:text-[12px] xl:text-[14px] 2xl:text-[14px] 2xl:leading-[24px] 2xl:font-[400] text-center lg:mt-[18px] xl:mt-[20px] 2xl:mt-[22px] text-xs">
                            {desc}
                        </div>
                    </div>
                </div>
                <div className="stepperStep h-[2rem] w-[10rem] md:h-[5rem] md:w-[7rem] lg:h-[7rem] lg:w-[9rem] xl:h-[9rem] xl:w-[12rem] 2xl:h-[11rem] 2xl:w-[15rem]"></div>
            </div>
            <div className={`upperBox hidden md:flex bg-transparent flex items-center flex-row md:flex-col ${isReverse && "md:flex-col-reverse flex-row-reverse"}`}>
                <div className={`stepperStep bg-transparent  md:mt-0 w-[9rem] h-[8rem]  md:h-[11rem] md:w-[7rem]  lg:h-[14rem] lg:w-[9rem] xl:h-[20rem] xl:w-[12rem] 2xl:mt-[10rem] ${isReverse && "!mt-[7rem] lg:!h-[16rem]"} 2xl:h-[22rem] 2xl:w-[18rem] 2xl:p-4 bg-white`} >
                    <div className={`stepContainer bg-step md:bg-none md:h-[9rem] ${isReverse && "md:!h-[4rem] xl:!h-[12rem] lg:!h-[8rem] 2xl:!h-[9rem]"}  w-full h-[6rem] lg:h-[10rem] xl:h-[11rem] 2xl:h-[12rem] bg-cover bg-center flex justify-center items-center`}>
                        <div className="StepNumer md:hidden lg:text-[16px] xl:text-[24px] 2xl:text-[26px] 2xl:font-[400] text-[#FFD700] -mt-3 lg:-mt-5">STEP {stepNum}</div>
                    </div>
                    <div className="content bg-transparent">
                        <div className="heading  md:text-[12px] lg:text-[14px] xl:text-[18px] 2xl:text-[24px] 2xl:leading-[24px] font-[700] text-center">
                            {heading}
                        </div>
                        <div className="desc md:text-[10px] lg:text-[12px] xl:text-[14px] 2xl:text-[14px] 2xl:leading-[24px] 2xl:font-[400] text-center lg:mt-[5px] xl:mt-[10px] 2xl:mt-[15px] text-xs">
                            {desc}
                        </div>
                    </div>
                </div>
                <div className={`stepperStep h-[2rem] w-[10rem] md:h-[5rem] md:w-[7rem] lg:h-[5rem]  lg:w-[9rem] xl:h-[0rem]  xl:w-[12rem] 2xl:h-[11rem] 2xl:w-[15rem]`}></div>
            </div>
        </>
    )
}

const Stepper = () => {
    // console.log(forwardLine,backwardLine)
    const data = [
        {
            heading: "Sign up for free",
            desc: "Start for free or get yourself a plan that fulfils your needs",
            key: "1k",
            isReverse: false
        },
        {
            heading: "Log in to Game Creation Platform",
            desc: "Jump onto our game creation platform to get started",
            key: "2k",
            isReverse: true
        },
        {
            heading: "Create your assessment game",
            desc: "Customize your game by choosing assessments, adding art screens, etc ",
            key: "3k",
            isReverse: false
        },
        {
            heading: " Launch your assessment game",
            desc: "Review and start rolling out your assessment game",
            key: "4k",
            isReverse: true
        },
        {
            heading: "Send invites to your candidates",
            desc: "Choose if you want to send bulk invites or to just a few ones",
            key: "5k",
            isReverse: false
        },
    ]
    return (
        <div className="wrapper flex justify-center md:mt-0 mt-[5rem]">
            <div className="stepper md:-top-4 z-10 flex flex-wrap items-center md:justify-between w-[90vw] lg:w-[50rem] xl:w-[62rem] 2xl:w-[91rem] relative flex-col md:flex-row">
                <img src={stepper} className="absolute hidden md:block" alt="" />
                <img src={stepperMobile} className="absolute  md:hidden h-[42rem] mt-[-3rem]" alt="" />
                {
                    data.map((box, index) => (
                        <Box stepNum={index + 1} key={'step' + index + box.key} isReverse={box.isReverse} heading={box.heading} desc={box.desc} />
                    )
                    )

                }
                {/* <img className='absolute  md:hidden w-[13rem]  rotate-[9deg]  -left-10 right-0 mr-auto ml-auto  mt-[2.5rem] sm:mt-[7%]' src={phoneConnector} alt="" /> */}

                {/* <img className='absolute -z-10  hidden md:block md:w-[83%] lg:w-[42rem] xl:w-[52rem] 2xl:w-[61rem]  md:rotate-0 left-0 right-0 mr-auto ml-auto md:top-[3.1rem] md:left-[-4px] lg:top-[5rem] lg:left-[-4px]  xl:top-[5.5rem] xl:left-[-4px]  2xl:top-[6.5rem] 2xl:left-[-4px]' src={connector} alt="" /> */}
                {/* <img className='absolute w-[17rem]  md:hidden md:w-[13rem]  rotate-12  -left-10 right-0 mr-auto ml-auto  mt-[2.5rem] sm:mt-[7%]' src={phoneConnector} alt="" /> */}


                {/* <img src={backwardLine} className="absolute  min-h-[8rem] max-h-[14rem] min-w-[5rem] max-w-[12rem] lg:left-[7%] xl:left-[7%] 2xl:left-[7%] lg:top-[60px] xl:top-[70px] 2xl:top-[88px]" alt="" />
                
                <img src={forwardLine} className="absolute min-h-[8rem] min-w-[7rem] max-h-[11rem] max-w-[12rem] lg:left-[28%] xl:left-[32%] 2xl:left-[28%] lg:top-[60px] xl:top-[70px] 2xl:top-[88px]" alt="" />
                
                <img src={backwardLine} className="absolute  min-h-[9rem] max-h-[14rem] min-w-[5rem] max-w-[12rem] lg:left-[51%] xl:left-[51%] 2xl:left-[51%] lg:top-[60px] xl:top-[70px] 2xl:top-[88px]" alt="" />
                <img src={forwardLine} className="absolute min-h-[8rem] min-w-[7rem] max-h-[11rem] max-w-[12rem] lg:left-[68%] xl:left-[73%] 2xl:left-[68%] lg:top-[60px] xl:top-[70px] 2xl:top-[88px]" alt="" /> */}

            </div>

        </div>
    )
}
export default Stepper